import uiRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';

// import modules this module depends on
import gzGo from 'gazelle/src/components/go/go.module';

// import this modules components
import './unsubscribe.scss';
import * as UnsubscribeController from './unsubscribe.controller';

export default angular.module('start.components.unsubscribe', [
  'rhino.core',
  'angulartics',
  uiRouter,
  angularTranslate,
  gzGo
])
  .controller(UnsubscribeController.name, UnsubscribeController.default)
  .name;



// WEBPACK FOOTER //
// ./components/unsubscribe/unsubscribe.module.js